/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var EditOutlineIcon = function EditOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1524 8.01027C22.5193 6.64344 22.5193 4.42736 21.1524 3.06053C19.7856 1.69369 17.5695 1.69369 16.2027 3.06053L3.8652 15.398C3.63807 15.6252 3.46898 15.9037 3.37225 16.21L1.81408 21.1442C1.70174 21.4999 1.79676 21.8886 2.06056 22.1524C2.32435 22.4162 2.71305 22.5112 3.0688 22.3989L8.003 20.8407C8.30931 20.744 8.58781 20.5749 8.81495 20.3478L21.1524 8.01027ZM19.7382 4.47474C20.324 5.06053 20.324 6.01027 19.7382 6.59606L19.3846 6.94968L17.2633 4.82836L17.6169 4.47474C18.2027 3.88895 19.1524 3.88895 19.7382 4.47474ZM15.8491 6.24257L5.27942 16.8122L4.30035 19.9126L7.40074 18.9335L17.9704 8.36389L15.8491 6.24257Z"
  }));
};
export default EditOutlineIcon;